import * as commonData from "../../../webapp-commons/data";

export const SERVICES = [...commonData.SERVICES];

export const FOLDER_STATUS = [
  { value: "submitted", text: "Déposé" },
  { value: "accepted", text: "Accepté" },
  { value: "rejected", text: "Rejeté" },
  { value: "unknown", text: "Inconnu" }
];

export const PROJECT_STATUS = [...commonData.PROJECT_STATUS];

export const ESTATE_TYPE = [
  { value: "apartment", text: "Appartement" },
  { value: "house", text: "Maison" }
];

export const STEPS = [
  {
    src: require("../assets/images/steps/cm1SF.png"),
    title: "Découverte de votre projet"
  },
  {
    src: require("../assets/images/steps/CM2SF.png"),
    title: "Constitution de votre dossier"
  },
  {
    src: require("../assets/images/steps/CM3SF.png"),
    title: "Proposition de biens"
  },
  {
    src: require("../assets/images/steps/CM4SF.png"),
    title: "Sélection des biens préférés"
  },
  {
    src: require("../assets/images/steps/CM5SF.png"),
    title: "Planification de visites"
  },
  {
    src: require("../assets/images/steps/CM6SF.png"),
    title: "Gestion administrative jusqu'à signature"
  }
];
